<template>
  <CRow>
    <CCol col="12" md="7">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/cow 4.svg" style="width:20px" /> Nutrient
          </p>
        </CCardHeader>

        <CCardBody>
          <CDataTable
            :items="speciesItem"
            :fields="fields"
            pagination
            clickable-rows
            hover
             table-filter
          items-per-page-select
          :items-per-page="10"
            @row-clicked="rowClicked"
            caption="Species"
          />
        </CCardBody>
      </CCard>
    </CCol>
    <CCol col="6" md="5">
      <CCard>
        <CCardHeader>
          <p>
            <img src="img/cow 4.svg" style="width:20px" /> Nutrient Details
          </p>
        </CCardHeader>
        <CCardBody>
          <CForm>
            <CInput label="nutrient name" horizontal autocomplete="name" v-model="nutrientname" />
            <CInput label="nutrient type" horizontal autocomplete="name" v-model="nutrienttype" />
            <CInput label="nutrientC" horizontal autocomplete="name" v-model="nutrientC" />
            <CInput label="unit" horizontal autocomplete="name" v-model="unit" />
            <CRow>
              <CCol sm="3">
                <h5 style="font-size:15px">Status</h5>
              </CCol>
              <CCol sm="3">
                <input type="checkbox" id="active" v-model="active" value="on" />
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
        <CCardFooter>
          <CButton color="info" style="width:100px" v-if="addButton" @click="addSpecies">
            <CIcon name="cilPencil" />&nbsp;Add
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="saveButton" @click="updateSpecies">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="success" style="width:100px" v-if="EditsaveButton" @click="addSpecies">
            <CIcon name="cilCheck" />&nbsp;Save
          </CButton>&nbsp;
          <CButton color="danger" style="width:100px" v-if="deleteButton" @click="deleteSpecies">
            <CIcon name="cilXCircle" />&nbsp;Delete
          </CButton>&nbsp;
          <CButton color="secondary" style="width:100px" v-if="cancelButton" @click="Cancelspecies">
            <CIcon name="cilWarning" />&nbsp;Cancel
          </CButton>

          <CButton color="info" v-if="addnewButton" @click="addnewspecies">
            <CIcon name="cilPencil" />&nbsp;Add New
          </CButton>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import CTableWrapper from "../../../tables/Table";
import { APIService } from "../../../../apiservice.js";
import Swal from "sweetalert2";
export default {
  components: { CTableWrapper },
  data() {
    return {
      fields: [
        {
          key: "nutrientname",
          sortable: true
        },
        {
          key: "nutrienttype",
          sortable: true
        },
        {
          key: "nutrientC",
          sortable: true
        },
        {
          key: "unit",
          sortable: true
        },
        // {
        //   key: "active",
        //   sortable: true
        // }
      ],

      nutrientname: null,
      nutrienttype: "",
      nutrientC: "",
      unit: "",
      active: false,
      speciesItem: [],
      editSpecies: [],
      addButton: false,
      saveButton: false,
      deleteButton: false,
      addnewButton: true,
      cancelButton: false,
      EditsaveButton: false
    };
  },
  methods: {
    getnutrientList() {
      APIService.nutrientList().then(res => {
        if (res.status == 200) {
          this.speciesItem = res.data;

            this.nutrientname =  this.speciesItem[0].nutrientname;
      this.nutrienttype = this.speciesItem[0].nutrienttype;
      this.nutrientC = this.speciesItem[0].nutrientC;
        this.unit = this.speciesItem[0].unit;
      this.active =this.speciesItem[0].active;
        }
      });
    },
    rowClicked(item, index, column, e) {
      console.log("edit item", item, index, column, e);

      this.editSpecies = item;
      this.nutrientname = item.nutrientname;
      this.nutrienttype = item.nutrienttype;
      this.nutrientC = item.nutrientC;
      this.unit = item.unit;
      this.active = item.active;
      this.addButton = false;
      this.saveButton = true;
      this.deleteButton = true;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false;
    },
    addnewspecies() {
      this.nutrientname = null;
      this.nutrienttype = "";
      this.nutrientC = "";
      this.unit = "";
      this.active = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = true;
      this.addnewButton = false;
      this.EditsaveButton = true
      return getnutrientList();
    },
    Cancelspecies() {
      this.nutrientname = null;
      this.nutrienttype = "";
      this.nutrientC = "";
      this.unit = "";
      this.active = "";
      this.addButton = false;
      this.saveButton = false;
      this.deleteButton = false;
      this.cancelButton = false;
      this.addnewButton = true;
      this.EditsaveButton = false,
       this.getnutrientList();
    },

    addSpecies() {
      let nutrientname = this.nutrientname;
      let nutrienttype = this.nutrienttype;
      let nutrientC = this.nutrientC;
      let unit = this.unit;
      let active = this.active;
      let data = {
        nutrientname,
        nutrienttype,
        nutrientC,
        unit,
        active
      };
      APIService.saveNutrient(data).then(res => {
        if (res.status == 200) {
          this.nutrientname = null;
          this.nutrienttype = "";
          this.nutrientC = "";
          this.unit = "";
          this.active = "";
          this.getnutrientList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    updateSpecies() {
      let id = this.editSpecies._id;
      let nutrientname = this.nutrientname;
      let nutrienttype = this.nutrienttype;
      let nutrientC = this.nutrientC;
      let unit = this.unit;
      let active = this.active;
      let value = {
        nutrientname,
        nutrienttype,
        nutrientC,
        unit,
        active
      };
      let data = { id, value };
      APIService.nutrientUpdate(data).then(res => {
        if (res.status == 200) {
          this.nutrientname = null;
          this.nutrienttype = "";
          this.nutrientC = "";
          this.unit = "";
          this.active = "";
          this.addButton = false;
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
         this.getnutrientList();
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Data Saved Successfully",
            showConfirmButton: false,
            timer: 2000
          });
        }
      });
    },
    deleteSpecies() {
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });

      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            swalWithBootstrapButtons.fire(
              "Deleted!",
              "Your file has been deleted.",
              "success"
            );
            this.delete();
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === Swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    delete() {
      let id = this.editSpecies._id;
      let data = { id };
      APIService.nutrientDelete(data).then(res => {
        if (res.status == 200) {
          this.nutrientname = null;
          this.nutrienttype = "";
          this.nutrientC = "";
          this.unit = "";
          this.active = "";
          this.saveButton = false;
          this.deleteButton = false;
          this.cancelButton = false;
          this.addnewButton = true;
          this.EditsaveButton = false,
            this.getnutrientList();
        }
      });
    }
  },
  created() {
    this.getnutrientList();
  }
};
</script>
<style scoped>
tbody > tr > :nth-child(1) {
  color: red;
  width: 200px;
  text-align: center;
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border: inset;
}
</style>